import { Stack } from '@christiankaindl/lyts'
import { type ReactNode } from 'react'
import Text from '../Text/Text'
import * as styles from './ListBox.css'

interface Props {
  title?: string
  /** Displayed below the title */
  subTitle?: string
  /** Displayed below the listbox */
  description?: string
  children: ReactNode
  flat?: boolean
}

export default function ListBox ({ title, subTitle, description, children, flat = false }: Props) {
  const listBox = (
    <div className={`${styles.root}${flat ? styles.flat : ''}`}>
      {children}
    </div>
  )

  if (!title && !subTitle && !description) {
    return listBox
  }

  return (
    <Stack gap={0.5}>
      <Text weight='bold'>{title}</Text>
      {description && (
        <Text color='secondary'>
          {description}
        </Text>
      )}
      {listBox}
    </Stack>
  )
}
